var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAppConfig } from '@mc/react-app-base';
import { Api, ZboApi } from '../api';
import { actionApiCall } from '@mc/react-app-v4';
export const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
export const openOrDownloadSoubor = (idPripad, dokumentId, download = false) => {
    return actionApiCall(() => __awaiter(void 0, void 0, void 0, function* () {
        let response;
        // Stahování konkrétního nebo všech dokumentů
        if (typeof dokumentId === 'number') {
            response = yield ZboApi.downloadDokument(idPripad, dokumentId, {
                responseType: 'blob',
            });
        }
        else {
            response = yield ZboApi.downloadDokumenty(idPripad, dokumentId, {
                responseType: 'blob',
            });
        }
        const blob = response.data;
        if (blob.size === 0 || blob.type === 'text/xml') {
            throw new Error('Neplatný dokument nebo dokument nenalezen.');
        }
        const contentDisposition = response.headers['content-disposition'];
        let filename = dokumentId === undefined ? 'dokumenty.zip' : 'dokument.pdf';
        if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches === null || matches === void 0 ? void 0 : matches[1]) {
                filename = matches[1];
            }
        }
        if (download) {
            downloadBlob(blob, filename);
        }
        else {
            const appConfig = useAppConfig();
            const localVarAxiosParamCreator = Api.ZbocControllerApiAxiosParamCreator();
            let path;
            if (typeof dokumentId === 'number') {
                path = (yield localVarAxiosParamCreator.downloadDokument(idPripad, dokumentId)).url;
            }
            else {
                path = (yield localVarAxiosParamCreator.downloadDokumenty(idPripad, dokumentId)).url;
            }
            window.open(`${appConfig.serverContextPath}${path}`, '_blank');
        }
    }));
};
export const downloadDokumentSoubor = (idPripad_1, dokumentId_1, ...args_1) => __awaiter(void 0, [idPripad_1, dokumentId_1, ...args_1], void 0, function* (idPripad, dokumentId, download = true) {
    yield openOrDownloadSoubor(idPripad, dokumentId, download);
});
export const openOrDownloadZadostSoubor = (zadostId, dokumentId, download = false) => {
    return actionApiCall(() => __awaiter(void 0, void 0, void 0, function* () {
        let response;
        if (typeof dokumentId === 'number') {
            response = yield ZboApi.downloadDokumentZadosti(zadostId, dokumentId, {
                responseType: 'blob',
            });
        }
        else {
            response = yield ZboApi.downloadDokumentyZadosti(zadostId, dokumentId, {
                responseType: 'blob',
            });
        }
        const blob = response.data;
        if (blob.size === 0 || blob.type === 'text/xml') {
            throw new Error('Neplatný dokument nebo dokument nenalezen.');
        }
        const contentDisposition = response.headers['content-disposition'];
        let filename = Array.isArray(dokumentId) ? 'dokumenty.zip' : 'dokument.pdf';
        if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches === null || matches === void 0 ? void 0 : matches[1]) {
                filename = matches[1];
            }
        }
        if (download) {
            downloadBlob(blob, filename);
        }
        else {
            const appConfig = useAppConfig();
            const localVarAxiosParamCreator = Api.ZbocControllerApiAxiosParamCreator();
            let path;
            if (typeof dokumentId === 'number') {
                path = (yield localVarAxiosParamCreator.downloadDokumentZadosti(zadostId, dokumentId)).url;
            }
            else {
                path = (yield localVarAxiosParamCreator.downloadDokumentyZadosti(zadostId, dokumentId)).url;
            }
            window.open(`${appConfig.serverContextPath}${path}`, '_blank');
        }
    }));
};
export const downloadDokumentZadostSoubor = (zadostId_1, dokumentId_1, ...args_1) => __awaiter(void 0, [zadostId_1, dokumentId_1, ...args_1], void 0, function* (zadostId, dokumentId, download = true) {
    yield openOrDownloadZadostSoubor(zadostId, dokumentId, download);
});
//# sourceMappingURL=urls.js.map